import { create } from "zustand";
import api from "../service/api";

interface FirmModulesStore {
  loading: boolean;
  getFirmModules: (firmId: number) => Promise<any>;
  applyPackage: (firmId: number, packageName: string, months: number) => Promise<boolean>;
  updatePermissions: (data: any) => Promise<boolean>;
}

export const useFirmModulesStore = create<FirmModulesStore>((set) => ({
  loading: false,

  getFirmModules: async (firmId: number) => {
    set({ loading: true });
    try {
      const res = await api.get(`/firm-modules/${firmId}/admin-view`);
      set({ loading: false });
      return res.data;
    } catch (err) {
      set({ loading: false });
      return null;
    }
  },

  applyPackage: async (firmId: number, packageName: string, months: number) => {
    set({ loading: true });
    try {
      await api.post(`/firm-modules/${firmId}/apply-package`, { packageName, months });
      set({ loading: false });
      return true;
    } catch (err) {
      set({ loading: false });
      return false;
    }
  },

  updatePermissions: async (data: any) => {
    set({ loading: true });
    try {
      await api.post(`/firm-modules/update-permissions`, data);
      set({ loading: false });
      return true;
    } catch (err) {
      set({ loading: false });
      return false;
    }
  }
}));